import { Box, Flex } from 'components/elements'
import { ShimmerCss, Tags1Css, TextShimmer } from '.'
import { AvatarShimmer } from './avatar'

export const NotificationShimmer = () => {
  return (
    <Flex
      justify={'between'}
      css={{ width: '100%', p: '$space$20', borderBottom: '1px solid $border' }}
    >
      <AvatarShimmer
        showToggle={true}
        showIcon={true}
        iconStyle="rounded"
        iconSize="md"
      />
      <Flex>
        <Box css={{ ...ShimmerCss, ...Tags1Css, mr: '$space$5' }}></Box>
        <TextShimmer css={{ m: 0 }} />
      </Flex>
    </Flex>
  )
}
